/* -------------------------------------------------------------------------- */
/* Namespaces et rooms                                                         */
/* -------------------------------------------------------------------------- */
export const SOCKET_NAMESPACES = {
    CLIENT: '/client',
    ADMIN: '/admin',
};
/**
 * Constructeurs de noms de rooms. Le serveur inscrit lui-meme les sockets
 * apres la poignee de main ; un client ne demande jamais a rejoindre une room.
 */
export const rooms = {
    session: (sessionId) => `session:${sessionId}`,
    restaurantPublic: (restaurantId) => `restaurant-public:${restaurantId}`,
    restaurantAdmin: (restaurantId) => `restaurant:${restaurantId}`,
    restaurantRole: (restaurantId, role) => `restaurant:${restaurantId}:role:${role}`,
};
/* -------------------------------------------------------------------------- */
/* Noms d'evenements                                                           */
/* -------------------------------------------------------------------------- */
export const SERVER_EVENTS = {
    ORDER_CREATED: 'order:created',
    ORDER_STATUS_CHANGED: 'order:status_changed',
    ORDER_UPDATED: 'order:updated',
    INVOICE_CREATED: 'invoice:created',
    INVOICE_READY: 'invoice:ready',
    NOTIFICATION_CREATED: 'notification:created',
    PAYMENT_DECLARED: 'payment:declared',
    PAYMENT_VERIFIED: 'payment:verified',
    MENU_ITEM_CREATED: 'menu:item_created',
    MENU_ITEM_UPDATED: 'menu:item_updated',
    MENU_ITEM_DELETED: 'menu:item_deleted',
    MENU_AVAILABILITY_CHANGED: 'menu:availability_changed',
    SESSION_OPENED: 'session:opened',
    SESSION_CLOSED: 'session:closed',
    TABLE_UPDATED: 'table:updated',
};
/** Seul message montant autorise. Sans effet metier. */
export const CLIENT_EVENTS = {
    PING: 'ping:app',
    PONG: 'pong:app',
};
/* -------------------------------------------------------------------------- */
/* Erreurs de poignee de main                                                  */
/* -------------------------------------------------------------------------- */
export const SOCKET_AUTH_ERRORS = ['UNAUTHORIZED', 'TOKEN_EXPIRED', 'SESSION_EXPIRED'];
//# sourceMappingURL=index.js.map